(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("styled-components"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "styled-components", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["nutrient"] = factory(require("react"), require("styled-components"), require("react-dom"));
	else
		root["nutrient"] = factory(root["React"], root[undefined], root["ReactDOM"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__9__) {
return 